
export default {
  name: 'ScoringMethodologyGlossaryItem',

  props: {
    image: {
      type: Object,
      default: () => ({}),
    },
    title: String,
    description: String,
    mode: String,

  },

  data() {
    return {
    }
  },
}
